export const BREAK_POINT = 750;

// TODO: CDNのURLは環境毎に分けるべき
export const DEFAULT_OPTIN_DIALOG_ICON_URL = 'https://cdn.webpush.jp/logo-coins.png';

// export const PINTO_EVENT_API = 'https://service.plan-b.co.jp/wp-json/wp/v2/event/?_embed&per_page=50';
